(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveLimitDeleteV2Controller', ReserveLimitDeleteV2Controller);

    ReserveLimitDeleteV2Controller.$inject = ['$uibModalInstance', 'entity', 'ReserveLimit'];

    function ReserveLimitDeleteV2Controller($uibModalInstance, entity, ReserveLimit) {
        var vm = this;


        vm.reserveLimit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ReserveLimit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
